import React, { useState, useEffect } from "react";
import axios from "../../services/api";
import "../../styles/UserForm.css";

// Roles that get cross-entity access (branch_id = null automatically)
const SENIOR_ROLES = ["superadmin", "store_manager", "Management", "Principal"];

const UserForm = ({ userId, onClose, refreshUsers }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    role: "user",
    phone: "",
    activated: true,
    branch_id: "",
  });

  const [branches, setBranches] = useState([]);
  const [error, setError] = useState("");

  // Fetch branches for the dropdown
  useEffect(() => {
    axios.get("/branches")
      .then((res) => setBranches(res.data))
      .catch(console.error);
  }, []);

  // Fetch user details when editing
  useEffect(() => {
    if (userId) {
      axios.get(`/users/${userId}`)
        .then((response) => {
          setFormData({ ...response.data, password: "", branch_id: response.data.branch_id || "" });
        })
        .catch(console.error);
    }
  }, [userId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Validate branch for non-senior roles
    if (!SENIOR_ROLES.includes(formData.role) && !formData.branch_id) {
      setError("Please select an entity for this user.");
      return;
    }

    try {
      if (userId) {
        await axios.put(`/users/${userId}`, formData);
      } else {
        await axios.post("/users", formData);
      }
      refreshUsers();
      onClose();
    } catch (error) {
      console.error("Error saving user:", error);
      if (error.response?.status === 400) {
        setError(error.response.data.error);
      } else {
        setError("An error occurred. Please try again.");
      }
    }
  };

  const isSeniorRole = SENIOR_ROLES.includes(formData.role);

  return (
    <div className="modal-overlay">
      <div className="modal-content user-modal">
        <div className="modal-header">
          <h3>{userId ? "Edit User" : "Add User"}</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        {error && <p className="error-message">{error}</p>}

        <form onSubmit={handleSubmit} className="user-form">
          <div className="form-group">
            <label>Name:</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label>Email:</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label>Password:</label>
            <input type="password" name="password" value={formData.password} onChange={handleChange} required={!userId} />
          </div>

          <div className="form-group">
            <label>Phone:</label>
            <input type="text" name="phone" value={formData.phone} onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label>Role:</label>
            <select name="role" value={formData.role} onChange={handleChange} required>
              <option value="store_manager">Store Manager</option>
              <option value="user">User</option>
              <option value="admin">Admin</option>
              <option value="superadmin">Super Admin</option>
              <option value="Management">Management</option>
              <option value="Principal">Principal</option>
            </select>
          </div>

          {/* Entity / Branch — shown for non-senior roles */}
          <div className="form-group">
            <label>Entity Access:</label>
            {isSeniorRole ? (
              <input
                type="text"
                value="Both Entities (Auto)"
                disabled
                style={{ background: "#f0f0f0", color: "#888", cursor: "not-allowed" }}
              />
            ) : (
              <select name="branch_id" value={formData.branch_id} onChange={handleChange} required>
                <option value="">-- Select Entity --</option>
                {branches.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
            )}
          </div>

          <div className="form-group checkbox-group">
            <input type="checkbox" name="activated" checked={formData.activated} onChange={handleChange} />
            <label>Activated</label>
          </div>

          <div className="form-actions">
            <button type="submit" className="save-btn">{userId ? "Update" : "Add"}</button>
            <button type="button" className="cancel-btn" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserForm;
